var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canAttach)?_c('div',{staticClass:"attach"},[_c('label',{attrs:{"for":"file-attachment"}},[_c('PaperclipIcon')],1),_c('input',{attrs:{"id":"file-attachment","data-qa":"msg-input-file-input","type":"file","multiple":"","accept":_vm.acceptedTypes},on:{"input":_vm.handleFileSelect}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }